import React from 'react';
import { Badge } from '@mantine/core';
import { SubredditBadgeProps } from './SubredditBadge.types';

/**
 * SubredditBadge Component
 *
 * Displays a subreddit name as a clickable badge
 *
 * Features:
 * - Shows subreddit with 'r/' prefix
 * - Clickable to filter mentions by subreddit
 * - Color-coded for visual distinction
 *
 * Usage:
 * ```tsx
 * <SubredditBadge subreddit="Seattle" />
 * <SubredditBadge subreddit="Seattle" onClick={() => filterBySubreddit('Seattle')} />
 * <SubredditBadge subreddit="AskSeattle" showPrefix={false} />
 * ```
 */
export const SubredditBadge: React.FC<SubredditBadgeProps> = ({
  subreddit,
  size = 'md',
  variant = 'light',
  onClick,
  showPrefix = true
}): React.ReactElement => {
  const displayText = showPrefix ? `r/${subreddit}` : subreddit;

  return (
    <Badge
      color="blue"
      variant={variant}
      size={size}
      style={onClick ? { cursor: 'pointer' } : undefined}
      onClick={onClick}
    >
      {displayText}
    </Badge>
  );
};
